<app-mediego-confirmation-dialog acceptLabel="{{ 'SHARED.QUIT_CONFIRMATION_DIALOG.ACCEPT_LABEL' | translate }}"
                                 declineLabel="{{ 'SHARED.QUIT_CONFIRMATION_DIALOG.DECLINE_LABEL' | translate }}">
  {{ 'SHARED.QUIT_CONFIRMATION_DIALOG.TITLE' | translate }}
</app-mediego-confirmation-dialog>
